angular.module('natgeo').controller('Level4RewardScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'Printer', 'ScreenView', 'UserProgress', 'Analytics',
function Level4RewardScreen($scope, element, ScreenFactory, manager, container, Printer, ScreenView, UserProgress, Analytics)
{
	var screen = ScreenFactory( 'level4_reward', element );
	
	screen.once('introBefore', function()
	{
		
	});

	// Level completed!
	screen.on('introBefore', function()
	{
		UserProgress.Level4 = 1;
		UserProgress.savePasscode();

		Analytics.complete('Ocean Cleanup');

		$scope.passcode = UserProgress.getPasscode();
		$scope.$apply();
	});	
	
	// Print the reward
	$scope.print = function()
	{
		Printer( 'level4/images/level4_certificate.pdf' );
	};

	// The next screen is the office screen
	$scope.next = function()
	{
		ScreenView.change('splash', 'splash_menu', true, undefined, 'loading_menu');
	};
	
	// The previous screen is the office screen
	$scope.prev = function()
	{
		manager.transition('level4_test');
	};
	
}]);